export type ShouldInsertWorkspaceAgentComposerPlainTextPasteParams = {
  html: string | undefined;
  text: string | undefined;
};

/**
 * HTML clipboard parse collapses `\n` inside a single wrapping tag. Structured HTML (adjacent
 * paragraphs, `<br>`) already maps to breaks, and re-splitting ProseMirror's `\n\n` plain text
 * inserts extra blank lines. Only intercept the collapsing case.
 */
export const shouldInsertWorkspaceAgentComposerPlainTextPaste = ({
  html,
  text,
}: ShouldInsertWorkspaceAgentComposerPlainTextPasteParams): boolean => {
  if (!text?.includes('\n')) {
    return false;
  }

  if (html?.includes('data-workspace-agent-pill') || html?.includes('data-workspace-agent-skill-moniker')) {
    return false;
  }

  if (html && /<br/i.test(html)) {
    return false;
  }

  const blockOpenCount = html?.match(/<(p|div|li|h[1-6])\b/gi)?.length ?? 0;

  return blockOpenCount < 2;
};
